import { IDeepCopy } from '@common/interfaces/i-deep-copy';
import { IEquals } from '@src/suite/common/interfaces/i-equals';
import { IToString } from '@src/suite/common/interfaces/i-to-string';

export class LookupListItem implements IToString {
    constructor(
        public id?: string,
        public displayText?: string,
        public description?: string
    ) {}

    public equals(target: LookupListItem): boolean {
        if (!target) return false;
        return this.id === target.id && this.displayText === target.displayText && this.description === target.description;
    }

    public toString(): string {
        return this.displayText;
    }
}

export class LookupList extends Array<LookupListItem> implements IDeepCopy<LookupList>, IEquals<LookupList>, IToString {
    constructor(...items: LookupListItem[]) {
        super(...items);
        Object.setPrototypeOf(this, LookupList.prototype);
    }

    public clear() {
        this.length = 0;
    }

    public set(prop: LookupListItem) {
        // this.cachedKeys = null;
        const index = this.indexOf(prop);
        if (index === -1) this.push(prop);
    }

    public delete(prop: LookupListItem) {
        // this.cachedKeys = null;
        const index = this.indexOf(prop);
        this.splice(index, 1);
    }

    public get(prop: LookupListItem): LookupListItem | undefined {
        return this.find((v: LookupListItem) => v === prop);
    }

    // public getProperties(): Array<T> {
    // 	return this;
    // }

    public equals(target: LookupList): boolean {
        if (!target) return false;
        for (const prop of this) {
            if (!target.get(prop)) return false;
        }
        for (const prop of target) {
            if (!this.get(prop)) return false;
        }
        return true;
    }

    public hasKey(key: LookupListItem): boolean {
        return this.some((v: LookupListItem) => v === key);
    }

    public hasValues(): boolean {
        return !!this.length;
    }

    public toString(): string {
        let ret = '';
        let first = true;
        for (const prop of this) {
            if (first) {
                first = false;
                ret += prop.toString();
            } else {
                ret += `, ${prop.toString()}`;
            }
        }
        return ret;
    }

    public toJSON() {
        return Object.keys(this);
    }

    public fromJSON(json: string): LookupList {
        const obj = JSON.parse(json);
        const ret = new LookupList();
        if (obj && obj.length) {
            for (const v of obj) {
                ret.set(<LookupListItem>v);
            }
        }
        return ret;
    }

    public deepCopy(): LookupList {
        const ret = new LookupList();
        for (const prop of this) {
            ret.set(prop);
        }
        return ret;
    }
}
